import React from 'react'
import DashBoard from './dashboard'

const DashboardMain = () => (
  <>
    <DashBoard />
  </>
)

export default DashboardMain
